<template>
	<v-layout row wrap class="mt-5">
		<v-flex xs12>
			<p class="title">Programação</p>
			<template v-for="(item, id) of programming">
				<venture-chip :key="id" :vc_outline="true" :hasIcon="false" :vc_title="item"></venture-chip>
			</template>

			<v-divider class="mt-3"></v-divider>
		</v-flex>

		<v-flex xs12 class="pt-3">
			<p class="title">Frameworks</p>
			<template v-for="(item, id) of frameworks">
				<venture-chip :key="id" :vc_outline="true" :hasIcon="false" :vc_title="item"></venture-chip>
			</template>

			<v-divider class="mt-3"></v-divider>
		</v-flex>

		<v-flex xs12 class="pt-3">
			<p class="title">Armazenamento</p>
			<template v-for="(item, id) of storage">
				<venture-chip :key="id" :vc_outline="true" :hasIcon="false" :vc_title="item"></venture-chip>
			</template>

			<v-divider class="mt-3"></v-divider>
		</v-flex>

		<v-flex xs12 class="pt-3">
			<p class="title">Versionamento</p>
			<template v-for="(item, id) of versioning">
				<venture-chip :key="id" :vc_outline="true" :hasIcon="false" :vc_title="item"></venture-chip>
			</template>

			<v-divider class="mt-3"></v-divider>
		</v-flex>

		<v-flex xs12 class="pt-3">
			<p class="title">Programas</p>
			<template v-for="(item, id) of softwares">
				<venture-chip :key="id" :vc_outline="true" :hasIcon="false" :vc_title="item"></venture-chip>
			</template>
		</v-flex>
	</v-layout>
</template>

<script>
import VentureChip from '@/components/VentureChip'

export default {
	name: 'experience-item',
	components: {
		'venture-chip':VentureChip
	},
	data() {
		return {
			programming: ['C#', 'C++', 'Asp.NET', 'Lua', 'Javascript ES5/ES6'],
			frameworks: ['NodeJS', 'Express', 'Next', 'VueJS', 'Vuetify', 'ReactJS', 'Service Workers'],
			storage: ['MySQL', 'SQLServer', 'File System', 'SQLite', 'NoSQL', 'Firebird', 'Firebase', 'Browser Storage'],
			versioning: ['Git', 'Github', 'Bonobo Server'],
			softwares: ['Visual Studio', 'Visual Studio Code', 'Adobe Photoshop', 'Adobe Lightroom', 'Adobe After Effects', 'Adobe Premiere']
		}
	}
}
</script>
